<!-- Lab user header -->
@if (userRole === SettingsRoleEnum.lab) {
  <mat-toolbar [class.no-shadow]="isExpanded" >
    <button mat-icon-button (click)="expansion.toggle()">
      <mat-icon fontSet="material-icons">menu</mat-icon>
    </button>
    <span>
      <a
        mat-flat-button
        color="primary"
        routerLink="/lab/home"
        (click)="expansion.close()"
        >
        <img class="logo" src="assets/bids_logo.png" alt="bids_logo" />
      </a>
    </span>
    <span class="spacer" (click)="expansion.toggle()"></span>
    <span class="name" data-clarity-mask="true">{{ header?.name }}</span>
    <button
      mat-icon-button
      (click)="loggedOut.emit()"
      >
      <mat-icon fontSet="material-icons">power_settings_new</mat-icon>
    </button>
  </mat-toolbar>
}

<!-- Non-lab user header -->
@if (userRole !== SettingsRoleEnum.lab) {
  <mat-toolbar [class.no-shadow]="isExpanded">
    <button mat-icon-button (click)="expansion.toggle()">
      <mat-icon fontSet="material-icons">menu</mat-icon>
    </button>
    <span>
      <a
        mat-flat-button
        color="primary"
        routerLink=""
        (click)="expansion.close()"
        >
        <img class="logo" src="assets/bids_logo.png" alt="bids_logo" />
      </a>
      @if (isDevMode) {
        <span class="dev-mode">AMBIENTE DE DESENVOLVIMENTO</span>
      }
    </span>
    <span class="spacer" (click)="expansion.toggle()"></span>
    <span class="name" data-clarity-mask="true">{{ header?.name }}</span>
    <!-- The portal's launcher, when the account may open another application (app-switcher D4, D5) -->
    @if (switcherUrl; as apps) {
      <a mat-icon-button class="apps-link" [href]="apps" aria-label="Aplicações" title="Aplicações">
        <img src="assets/login-farmacias-mark.svg" width="24" height="24" alt="" aria-hidden="true" />
      </a>
    }
    <a mat-icon-button routerLink="/external/help" (click)="expansion.close()">
      <mat-icon fontSet="material-icons">help</mat-icon>
    </a>
    <button
      mat-icon-button
      (click)="loggedOut.emit()"
      >
      <mat-icon fontSet="material-icons">power_settings_new</mat-icon>
    </button>
  </mat-toolbar>
}
<mat-expansion-panel #expansion class="mat-elevation-z0 menu-panel" (opened)="onExpansionChange(true)" (closed)="onExpansionChange(false)">
  <div class="d-flex justify-content-around">
    @for (cluster of header?.clusters; track cluster) {
      <div>
        <ul>
          @for (item of cluster?.items; track item) {
            <li>
              <a
                class="header-link"
                mat-flat-button
                color="primary"
                [routerLink]="item.url"
                (click)="expansion.close()"
                >
                {{ item.name }}</a
                >
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </mat-expansion-panel>

<!-- Bottom bar: replaces the toolbar and its menu on touch screens and narrow windows (header.component.scss) -->
@if (header) {
  <nav class="bottom-bar" aria-label="Navegação">
    <a class="bottom-bar__brand" [routerLink]="homeUrl" (click)="closeMenus()" aria-label="Bidscircle">
      <img class="bottom-bar__logo" src="assets/bids_logo.png" alt="Bidscircle" />
      @if (isDevMode) {
        <span class="bottom-bar__dev">DEV</span>
      }
    </a>

    <div class="bottom-bar__sections">
      @for (item of barItems; track item.url) {
        <a
          class="bottom-bar__item"
          [routerLink]="item.url"
          routerLinkActive="bottom-bar__item--active"
          [routerLinkActiveOptions]="{ exact: isExactMatch(item) }"
          (click)="closeMenus()"
        >
          <span class="bottom-bar__indicator">
            <mat-icon fontSet="material-icons">{{ barIcon(item) }}</mat-icon>
          </span>
          <span class="bottom-bar__label">{{ barLabel(item) }}</span>
        </a>
      }
      @if (moreClusters.length > 0) {
        <button
          type="button"
          class="bottom-bar__item"
          [class.bottom-bar__item--active]="moreActive"
          [attr.aria-expanded]="moreOpen"
          (click)="toggleMore()"
        >
          <span class="bottom-bar__indicator">
            <mat-icon fontSet="material-icons">more_horiz</mat-icon>
          </span>
          <span class="bottom-bar__label">Mais</span>
        </button>
      }
    </div>

    <button
      type="button"
      class="bottom-bar__account"
      data-clarity-mask="true"
      [attr.aria-expanded]="accountOpen"
      [attr.aria-label]="'Conta: ' + header.name"
      (click)="toggleAccount()"
    >
      {{ initials }}
    </button>
  </nav>

  @if (moreOpen || accountOpen) {
    <div class="bottom-bar__scrim" (click)="closeMenus()"></div>
  }

  @if (moreOpen) {
    <div class="bottom-bar__panel bottom-bar__more" role="menu" aria-label="Mais">
      @for (item of moreItems; track item.url) {
        <a
          class="bottom-bar__link"
          role="menuitem"
          [routerLink]="item.url"
          routerLinkActive="bottom-bar__link--active"
          (click)="closeMenus()"
        >{{ item.name }}</a>
      }
    </div>
  }

  @if (accountOpen) {
    <div class="bottom-bar__panel bottom-bar__account-menu" role="menu" [attr.aria-label]="'Conta: ' + header.name">
      <span class="bottom-bar__account-name" data-clarity-mask="true">{{ header.name }}</span>
      @if (switcherUrl; as apps) {
        <a class="bottom-bar__link" role="menuitem" [href]="apps">
          <img src="assets/login-farmacias-mark.svg" width="24" height="24" alt="" aria-hidden="true" />
          Aplicações
        </a>
      }
      @if (userRole !== SettingsRoleEnum.lab) {
        <a class="bottom-bar__link" role="menuitem" routerLink="/external/help" (click)="closeMenus()">
          <mat-icon fontSet="material-icons">help</mat-icon>
          Ajuda
        </a>
      }
      <button type="button" class="bottom-bar__link" role="menuitem" (click)="logout()">
        <mat-icon fontSet="material-icons">power_settings_new</mat-icon>
        Terminar sessão
      </button>
    </div>
  }
}
